import {
    ChangeDetectionStrategy,
    Component,
    WritableSignal,
    signal,
} from '@angular/core';

import { PresenterType } from '@shared/components';
import { AuthTenantSelectionFailedMessage } from './auth-tenant-selection-failed.message';

@PresenterType({
    model: AuthTenantSelectionFailedMessage,
})
@Component({
    selector: 'auth-tenant-selection-failed-message-template',
    templateUrl: './auth-tenant-selection-failed-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AuthTenantSelectionFailedMessageTemplateComponent {
    public data: WritableSignal<AuthTenantSelectionFailedMessage>;

    constructor() {
        this.data = signal<AuthTenantSelectionFailedMessage>(null);
    }
}